import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import { ThemeProvider, CssBaseline } from '@mui/material';
import RtlProvider from './theme/RtlProvider';
import theme from './theme/theme';
// Set HTML direction to rtl
document.documentElement.setAttribute('dir', 'rtl');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RtlProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </RtlProvider>
  </React.StrictMode>

);